let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dWi3B")).then(() => parcelRequire('27EyS'));